import styled from "styled-components";

export const Box = styled.div`
    display: flex;
    padding: 1rem;
    border: 2px dashed #ccc;
    flex-direction: column;
`;
